import { marketAsyncComponent } from '@/utils/asyncComponent';

export default window.cell || marketAsyncComponent('cell', '0.0.3');

// import { marketRequire } from '@/utils/asyncComponent';

// export default window._rhinoComponents.Cell;
